import {
  INACTIVE_SET_FILTERS,
  INACTIVE_CLEAR_FILTERS,
  INACTIVE_SET_PAGE,
  INACTIVE_SET_PAGE_SIZE,
  INACTIVE_SET_SEARCH,
  INACTIVE_SET_SORT,
  INACTIVE_FETCH_REQUEST,
  INACTIVE_FETCH_SUCCESS,
  INACTIVE_FETCH_FAILURE,
} from '../actions/actionTypes';
import { InactiveAction } from '../actions/inactiveActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface InactiveState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: InactiveState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function inactiveReducer(
  state: InactiveState = initialState,
  action: InactiveAction,
): InactiveState {
  switch (action.type) {
    case INACTIVE_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case INACTIVE_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case INACTIVE_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case INACTIVE_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case INACTIVE_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case INACTIVE_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case INACTIVE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case INACTIVE_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case INACTIVE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
